import React from "react";
import { connect } from "react-redux";
import {formattedPrice} from "../../helpers/MainHelper";


class ServiceTypeReportTable extends React.Component {
  render() {
    const { bodyData } = this.props;
    return (

      <div className="table-responsive">
        <table className="table m-b-0 table-hover">
          <thead className="thead-light">
            <tr>
              <th>Servis Tipi</th>
              <th>Kayıt Sayısı</th>
              <th>Toplam</th>

            </tr>
          </thead>
          <tbody>
            {bodyData.map((data, i) => {
              return (
                <tr key={"dihf" + i}>
                  <td>
                    <span className="badge badge-success">{data.type}</span>
                  </td>
                  <td className="project-title">
                    {data.count}
                  </td>
                  <td>
                    {formattedPrice(data.total)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(ServiceTypeReportTable);
